import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';

import '../css/screens/NewsPage.scss';
import Link from '../css/ui/Link';
import Button from '../ui/Button';



export default class NewsPage extends Page {

	content:HTMLDivElement;
	scrollbar:HTMLDivElement;
	bar:HTMLDivElement;
	componentDidMount()
	{
		this._updateScroll();
		window.addEventListener('resize', this._updateScroll);
		if(this.content)
		{
			this.content.addEventListener('scroll', this._updateScroll);
		}
	}

	componentWillUnmount()
	{
		window.removeEventListener('resize', this._updateScroll);
		this.content?.removeEventListener('scroll', this._updateScroll);
	}

	private _updateScroll = () =>
	{
		let sb = this.scrollbar.getBoundingClientRect();
		if(sb.height >= this.content.scrollHeight)
		{
			this.scrollbar.style['display'] = 'none';
			return;
		}
		this.scrollbar.style['display'] = '';

		let p = sb.height / this.content.scrollHeight;
		this.bar.style['height'] = p * 100 + '%';
		let t = this.content.scrollTop / (this.content.scrollHeight - sb.height);
		console.log(t * (sb.height * (1 - p)));
		this.bar.style['top'] = t * (sb.height * (1 - p)) + 'px';
	}

	render() {

		console.log(this.props.content['title']);
		return this.wrap(
			<React.Fragment>
				<Grid className="padding" cols={3} skip={1} breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className='title'>{this.props.content.title}</div>
					<hr></hr>
					<div className='wrapper'>
						<div ref={r => this.content = r} className='topics'>
							{
								this.props?.content?.topics?.map((t, i) => {
									return (<Topic data={t} key={i}></Topic>);
								})
							}
						</div>
						<div ref={r => this.scrollbar = r} className='scrollbar'>
							<div ref={r => this.bar = r} className='bar'></div>
						</div>
					</div>
					<hr></hr>
				</Grid>
			</React.Fragment>
		);
	}
}


class Topic extends React.Component<{data:any}>
{
	render()
	{
		return (
			<div className="topic">
				<div className='date'>{this.props?.data?.date}</div>
				<div className='items'>
					<ul>
						{
							this.props?.data?.items?.map((e, i)=>{
								if(typeof(e) == 'string')
								{
									return (<li key={i}>{e}</li>);
								}else if(!e.link)
								{
									return (<li key={i}>{e.text}</li>);
								}else
								{
									return (<li key={i}><Link to={e.link}>{e.text}</Link></li>);
								}
							})
						}
					</ul>
				</div>
			</div>
		)
	}
}